import axios from 'axios'

const store = {
    namespaced: true,
    state: {
        users: [],
        groups: []
    },
    mutations: {
        users(state, users) {
            state.users = users
        },
        groups(state, groups) {
            state.groups = groups
        }
    },
    getters: {
        getUsers: (state) => {
            return state.users
        }
    },
    actions: {
        async createUser(context,userObj){
            try{
                await axios.post('api.public.Public/CreateGrnUser',userObj)
            }
            catch(e){
                alert(e)
            }
            
        },

        async updateUser(context,userObj){
            try{
                await axios.post('api.public.Public/UpdateGrnUser',userObj)
            }
            catch(e){
                alert(e)
            }
        },

        async deleteUser (context,userName){
            try{
                await axios.post('api.public.Public/DeleteGrnUser',{username:userName})
            }
            catch(e){
                alert(e)
            }
            
        },
        async fetchUsers(context) {
            try {
                let res = await axios.post('api.public.Public/GetGrnUsers',
                    {})
                let users = []
                res.data.users.forEach(
                        (user) =>{
                         if (user.cognitoUser) {
                            let attributesObj = user.cognitoUser.Attributes.reduce((obj, cur) => {return {...obj, [cur.Name]: cur.Value }}, {})
                            
                            let cogUserObj = {...attributesObj,...user.cognitoUser}
                            user.cognitoUser = cogUserObj
                            delete user.cognitoUser.Attributes
                            users.push(user) //merge custom attributes into user object
                         }else{
                            users.push(user.cognitoUser = {})
                         }
                        }
                          
                      )
                context.commit('users', res.data.users)
            }
            catch (error) {
                alert(error)
            } finally {
                // finally.
            }
        }
    }
}

export default store